import { render, staticRenderFns } from "./PgaOfferEvaluationHumanResourcesSubtotals.vue?vue&type=template&id=fdd423a6&"
import script from "./PgaOfferEvaluationHumanResourcesSubtotals.vue?vue&type=script&lang=ts&"
export * from "./PgaOfferEvaluationHumanResourcesSubtotals.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VChip,VCol,VContainer,VRow})


/* hot reload */
if (module.hot) {
  var api = require("/src/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fdd423a6')) {
      api.createRecord('fdd423a6', component.options)
    } else {
      api.reload('fdd423a6', component.options)
    }
    module.hot.accept("./PgaOfferEvaluationHumanResourcesSubtotals.vue?vue&type=template&id=fdd423a6&", function () {
      api.rerender('fdd423a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/feature/Offerte/OfferEvaluation/components/create/sub-components/sub-totals/PgaOfferEvaluationHumanResourcesSubtotals.vue"
export default component.exports